import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Shared/components/header/header.component';
import { FooterComponent } from './Shared/components/footer/footer.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './Shared/services/interceptor';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ApiDataService } from './Shared/services/apidata.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule,TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppService } from './Shared/services/app.service';
import { SEOserviceService } from './Shared/services/seoservice.service';
import { MatDialogModule } from '@angular/material/dialog';
import { CasestudydetailsComponent } from './casestudy/casestudydetails.component';
import { RegisterComponent } from './auth/register/register.component';
import { LoginComponent } from './auth/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { ProfileComponent } from './profile/profile.component';
import { SitebarCartComponent } from './sitebar-cart/sitebar-cart.component';
import { SharedModule } from './Shared/shared/shared.module';
import { DropdownService } from './Shared/services/dropdown.service';
import { MomentMatComponent} from './moment-mat/moment-mat.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HomeMainComponent } from './home-main/home-main.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MainContactUsComponent } from './main-contact-us/main-contact-us.component';
import { CareerComponent } from './career/career.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ProgramComponent } from './program/program.component';
import { ProgramDetailsComponent } from './program-details/program-details.component';
import { EventComponent } from './event/event.component';
import { ProgramDdanceComponent } from './program-ddance/program-ddance.component';
import { ProgramDteakwondoComponent } from './program-dteakwondo/program-dteakwondo.component';
import { ProgramDmusicComponent } from './program-dmusic/program-dmusic.component';
import { ProgramDgymnasticsComponent } from './program-dgymnastics/program-dgymnastics.component';
import { ProgramDyogaComponent } from './program-dyoga/program-dyoga.component';
import { ProgramDdramaticComponent } from './program-ddramatic/program-ddramatic.component';
import { ProgramDpotteryComponent } from './program-dpottery/program-dpottery.component';



export const createTranslateLoader = (http: HttpClient) => {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
  declarations: [ 
    AppComponent,
    HeaderComponent,
    FooterComponent,
    RegisterComponent,
    LoginComponent,
    ProfileComponent,
    SitebarCartComponent,
    MomentMatComponent,
    AboutUsComponent,
    HomeMainComponent,
    NavbarComponent,
    MainContactUsComponent,
    CareerComponent,
    GalleryComponent,
    ProgramComponent,
    ProgramDetailsComponent,
    EventComponent,
    ProgramDdanceComponent,
    ProgramDteakwondoComponent,
    ProgramDmusicComponent,
    ProgramDgymnasticsComponent,
    ProgramDyogaComponent,
    ProgramDdramaticComponent,
    ProgramDpotteryComponent
  ],

    imports: [
      SharedModule,
      BrowserModule,
      HttpClientModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      MatDialogModule,
      ReactiveFormsModule,
      FormsModule,
      MatDatepickerModule,
      MatSnackBarModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      ToastrModule.forRoot()],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    ApiDataService,
    TranslateService,
    AppService,
    DropdownService,
    SEOserviceService
  ],
  bootstrap: [AppComponent],

  entryComponents: [
    CasestudydetailsComponent,
    SitebarCartComponent
    ],



})
export class AppModule {}
